import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField, LineInputRange } from "ui";

import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const EarningsField = () => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<NotificationFormValues>();

  const notRelevantEarningsWatch = watch("notRelevantEarnings");

  return (
    <div>
      <Controller
        control={control}
        name={"earnings"}
        render={({
          field: { value, onChange },
          fieldState: { error: _error }
        }) => (
          <FormField
            label={`${t("Earnings")} (FCFA)`}
            labelClassName={styles.form_fieldLabel}
          >
            <LineInputRange
              values={value}
              min={1}
              max={9999999}
              onChange={onChange}
              withInputs
              disabled={notRelevantEarningsWatch}
            />
          </FormField>
        )}
      />

      <Controller
        control={control}
        name="notRelevantEarnings"
        render={({ field: { value, onChange } }) => (
          <Checkbox
            checked={value}
            label={t("Not Relevant")}
            onChange={onChange}
            className={styles.form_checkbox}
          />
        )}
      />
    </div>
  );
};
